import { connect } from 'react-redux'
import ModalActions from '../../../Redux/ModalRedux'
import DeepSleepModel from './deep-sleep-modal'
import deepSleepModalSelector from './deep-sleep-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    deepSleepModalSelector,
    mapDispatchToProps
  )
)(DeepSleepModel)
